import React, { useContext, useEffect, useMemo } from 'react';
import has from 'lodash/has';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getPpsisWithFilter } from '../features/PpsiContainer/selectors';
import {
  getNewPpiAvailabelData,
  getPpisNotUptoDate
} from '../features/PpiContainer/selectors';
import { getConfigs, getLanguage } from '../features/app/selectors';
import Table from '../components/Table/Table';
import usePpis from '../features/PpiContainer/hooks/usePpis';
import useViewVisited from '../features/app/hooks/useViewVisted';
import usePpsis from '../features/PpsiContainer/hooks/usePpsis';
import {
  EnrichmentData as PpsiEnrichmentData,
  States as PpsiStates
} from '../features/PpsiContainer/constants';
import {
  EnrichmentData as PpiEnrichmentData,
  States as PpiStates,
  States
} from '../features/PpiContainer/constants';
import {
  ppiPublishedRoute,
  ppsiPublishedRoute,
  ppiInProgressRoute,
  ppsiInProgressRoute,
  newIngredientsRoute,
  newGlobalDishesRoute,
  newDishesRoute,
  excludedDishesRoute,
  excludedIngredientsRoute
} from '../routes';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import useGlobalPpis from '../features/PpiContainer/hooks/useGlobalPpis';
import useGlobalPpsis from '../features/PpsiContainer/hooks/useGlobalPpsis';
import useIngredients from 'features/IngredientContainer/hooks/useIngredients';
import useDishes from 'features/DishContainer/hooks/useDishes';
import useExcludedDishes from 'features/DishContainer/hooks/useExcludedDishes';
import { toJS } from 'utils/immutableUtils';
import useExcludedIngredients from 'features/IngredientContainer/hooks/useExcludedIngredients';
import { fromJS } from 'immutable';
import { fetchNewPPIAvilableData } from 'features/PpiContainer/actions';
import { getIsGlobalUser } from 'features/loginSystem/selectors';

function isRowPpsi(rowData) {
  return rowData.type === 'PPSI';
}

const navigate = rowData => {
  let route = '';
  if (rowData.isExcluded && rowData.type === 'Dish') {
    route = excludedDishesRoute();
  } else if (rowData.isExcluded && rowData.type === 'Ingredient') {
    route = excludedIngredientsRoute();
  } else if (
    rowData.status === 'New' ||
    rowData.isUnused ||
    (typeof rowData.status === 'boolean' && !rowData.isExcluded)
  ) {
    route =
      rowData.type === 'Ingredient'
        ? newIngredientsRoute()
        : rowData.isGlobalBased
        ? newGlobalDishesRoute()
        : newDishesRoute();
  } else if (
    rowData.status === 'PUBLISHED' ||
    rowData.status === 'UNPUBLISHED'
  ) {
    route =
      rowData.type === 'PPSI'
        ? ppsiPublishedRoute(rowData.id)
        : ppiPublishedRoute(rowData.id);
  } else if (
    rowData.status === 'GLOBAL REVIEW' ||
    rowData.status === 'DRAFT' ||
    rowData.status === 'GLOBAL APPROVED' ||
    rowData.status === 'SCHEDULED' ||
    rowData.status === 'GLOBAL REJECTED' ||
    'INPROGRESS'
  ) {
    route =
      rowData.type === 'PPSI'
        ? ppsiInProgressRoute(rowData.id)
        : ppiInProgressRoute(rowData.id);
  } else {
    route = '';
  }
  return route;
};

function getEnrichmentData(rowData) {
  let enrichmentDataName;
  // if(rowData.itemCode==='FRF12099700'){
  //   debugger
  // }
  if (rowData.status === 'INPROGRESS' || rowData.status === false) {
    enrichmentDataName = isRowPpsi(rowData)
      ? PpsiEnrichmentData.IN_PROGRESS
      : PpiEnrichmentData.IN_PROGRESS;

    return rowData[enrichmentDataName];
  }
  if (
    (rowData.status === 'PUBLISHED' || rowData.status === 'UNPUBLISHED') &&
    !rowData.isUnused
  ) {
    enrichmentDataName = isRowPpsi(rowData)
      ? PpsiEnrichmentData.PUBLISHED
      : PpiEnrichmentData.PUBLISHED;

    return rowData[enrichmentDataName];
  }
  if (
    (rowData.status =
      'Approved' &&
      !Object.keys(rowData).includes('publishedPpsiEnrichmentData') &&
      !Object.keys(rowData).includes('publishedPPIEnrichmentData'))
  ) {
    return {
      ...rowData,
      status: rowData.isExcluded
        ? 'Excluded'
        : typeof rowData.status === 'boolean'
        ? 'New'
        : rowData.status,
      enrichmentStatus: rowData.isExcluded
        ? 'Excluded'
        : typeof rowData.enrichmentStatus === 'boolean'
        ? 'New'
        : rowData.enrichmentStatus
    };
  }
  if (
    (rowData.status === 'PUBLISHED' || rowData.status === 'DRAFT') &&
    rowData.isUnused
  ) {
    return rowData.presentationName;
  }
  return rowData[enrichmentDataName];
}

const removeDuplicates = array => {
  const seen = new Set();
  return array.filter(item => {
    if (seen.has(item.id)) {
      return false; // Skip if `id` is already in the set
    }
    seen.add(item.id); // Add `id` to the set
    return true;
  });
};

function excludePpis(ppis, ppisToExclude) {
  const excludeItemCodes = ppisToExclude.map(localPpi => localPpi.itemCode);
  return ppis.filter(ppi => {
    return !excludeItemCodes.includes(ppi.itemCode);
  });
}

// function includeNewPpiUpdateData(updatesData, localPpiData) {
//   // const update = updatesData.map(a => a.relationshipId);
//   // const fillteredUpdate = localPpiData
//   //   .filter(
//   //     a =>
//   //       update.includes(a.relationshipId) &&
//   //       ((a.inProgressPPIEnrichmentData &&
//   //         a.inProgressPPIEnrichmentData.parentPpiId) ||
//   //         (a.publishedPPIEnrichmentData &&
//   //           a.publishedPPIEnrichmentData.parentPpiId))
//   //   )
//   //   .map(a => a.relationshipId);
//   // return updatesData.filter(a => !fillteredUpdate.includes(a.relationshipId));
//   return localPpiData.filter(local=>{
//     if( updatesData.filter(update=>update.itemCode === local.itemCode && update.relationshipId === local.relationshipId).length){
//         return local
//     }

// })
// }

function includeNewPpiUpdateData(updatesData, localPpiData, globalData) {
  const globalUpdateData = globalData.filter(itm => {
    if (
      updatesData.filter(
        a => a.relationshipId === itm.itemCode && itm.status === 'PUBLISHED'
      ).length
    ) {
      return itm;
    }
  });

  const localfilter = localPpiData.filter(local => {
    if (
      updatesData.filter(
        update =>
          update.itemCode === local.itemCode &&
          update.relationshipId === local.relationshipId
      ).length
    ) {
      return local;
    }
  });

  const groupedByItemCode = localfilter.reduce((acc, item) => {
    if (!acc[item.itemCode]) acc[item.itemCode] = [];
    acc[item.itemCode].push(item);
    return acc;
  }, {});

  const grouped = groupedByItemCode;

  for (const itemCode in groupedByItemCode) {
    const group = groupedByItemCode[itemCode];
    const globalids = globalUpdateData.map(a => a.id);
    const hasParent = group.some(obj =>
      globalids.includes(
        (obj.inProgressPPIEnrichmentData &&
          obj.inProgressPPIEnrichmentData.parentPpiId) ||
          (obj.publishedPPIEnrichmentData &&
            obj.publishedPPIEnrichmentData.parentPpiId)
      )
    );
    if (hasParent) {
      delete grouped[itemCode];
    }
  }
  return Object.values(groupedByItemCode).flat();
}

function includePpis(ppis, ppisToExclude) {
  const dto = [];
  const code = [];
  ppisToExclude.filter(ppi => {
    const globalitemcode = ppis.filter(
      item => item.itemCode === ppi.relationshipId
    );

    if (globalitemcode !== null) {
      globalitemcode.forEach(gt => {
        if (
          (ppi.inProgressPPIEnrichmentData &&
            ppi.inProgressPPIEnrichmentData.parentPpiId &&
            gt.id !== ppi.inProgressPPIEnrichmentData.parentPpiId) ||
          (ppi.publishedPPIEnrichmentData &&
            ppi.publishedPPIEnrichmentData.parentPpiId &&
            gt.id !== ppi.publishedPPIEnrichmentData.parentPpiId)
        ) {
          // code.push({...gt});
          dto.push({ ...gt });
          // }else {
          //   dto.push({...gt});
          // }
        }
      });
    }
  });

  const o = dto.filter(
    a =>
      !ppisToExclude
        .map(a => {
          if (
            has(a, 'inProgressPPIEnrichmentData') &&
            a.inProgressPPIEnrichmentData
          ) {
            return a.inProgressPPIEnrichmentData.parentPpiId;
          }
          return a.publishedPPIEnrichmentData.parentPpiId;
        })
        .includes(a.id)
  );

  // const ppp = removeDuplicates(o);

  // return ppp;
  return removeDuplicates(dto);
}

function getLatestPublishedItem(data) {
  if (!Array.isArray(data) || data.length === 0) return null;

  return data.reduce((latest, current) => {
    const latestDate = new Date(
      latest.publishedPPIEnrichmentData.actualPublishedDate
    );
    const currentDate = new Date(
      current.publishedPPIEnrichmentData.actualPublishedDate
    );
    return currentDate < latestDate ? current : latest;
  });
}

function createTableData(
  ppsis,
  ppis,
  dishes,
  raw,
  excludedDishesRaw,
  newPpi,
  exIngredientRaw,
  ppiL,
  searchQuery,
  language,
  unUsedPpis
) {
  const ppsisWithType = ppsis.map(ppsi => ppsi.set('type', 'PPSI')).toJS();
  const ppsiNew = raw.map(ppsi => ppsi.set('type', 'PPSI')).toJS();
  const ppisWithType = ppis.map(ppi => ppi.set('type', 'PPI')).toJS();
  const ppi = ppiL.map(ppi => ppi.set('type', 'PPI')).toJS();
  const rowPpisWithType = newPpi
    .map(ppi => ppi.set('type', 'Ingredient'))
    .toJS();
  const rowUnusedPpis = unUsedPpis
    .map(ppi => ppi.set('type', 'Ingredient'))
    .map(ppi => ppi.set('isUnused', true))
    .toJS();
  const newDishes = dishes.map(ppsi => ppsi.set('type', 'Dish')).toJS();
  const excludedIngredient = exIngredientRaw
    .map(ppi => ppi.set('type', 'Ingredient'))
    .toJS();
  const exclude = excludedDishesRaw.map(ppi => ppi.set('type', 'Dish')).toJS();
  excludedIngredient.map(itm => ({ ...itm, status: 'Excluded' }));
  exclude.map(itm => ({ ...itm, status: 'Excluded' }));

  const versionPPSI = ppsisWithType.filter(
    a =>
      Object.keys(a).includes('publishedPpsiEnrichmentData') &&
      a.publishedPpsiEnrichmentData &&
      a.inProgressPpsiEnrichmentData &&
      Object.keys(a).includes('inProgressPpsiEnrichmentData')
  );

  versionPPSI.map(b =>
    ppsisWithType.push({
      ...b,
      publishedPpsiEnrichmentData: null,
      status: 'INPROGRESS',
      inProgressPpsiEnrichmentData: { ...b.inProgressPpsiEnrichmentData }
    })
  );

  const versionPPI = ppi.filter(
    a =>
      Object.keys(a).includes('publishedPPIEnrichmentData') &&
      a.publishedPPIEnrichmentData &&
      a.inProgressPPIEnrichmentData &&
      Object.keys(a).includes('inProgressPPIEnrichmentData')
  );

  versionPPI.map(b =>
    ppi.push({
      ...b,
      publishedPPIEnrichmentData: null,
      status: 'INPROGRESS',
      inProgressPPIEnrichmentData: { ...b.inProgressPPIEnrichmentData }
    })
  );

  const concatedData = ppsisWithType
    .concat(newDishes)
    // .concat(rowPpisWithType)
    .concat(rowUnusedPpis)
    .concat(exclude)
    .concat(excludedIngredient)
    .concat(ppi);

  return concatedData;
}

const formatFormulaCode = (formulaCode, version) => {
  let string = `${formulaCode.substring(0, 3)} ${formulaCode.substring(
    3,
    7
  )} ${formulaCode.substring(7, formulaCode.length)}`;
  if (version) {
    string = `${string}\\${version}`;
  }
  return string;
};

const formatItemCode = itemCode => {
  return `${itemCode.substring(0, 3)} ${itemCode.substring(
    3,
    7
  )} ${itemCode.substring(7, itemCode.length)}`;
};

const useStyles = makeStyles({
  inputRoot: {
    backgroundColor: '#fff',
    '& .MuiInputBase-root': {
      fontSize: '0.875rem'
    },
    '& input': {
      paddingTop: '12px',
      paddingBottom: '12px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.1)'
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderWidth: '1px'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)'
    }
  },
  searchIcon: {
    color: 'rgba(0, 0, 0, 0.54)'
  }
});

const SearchListView = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const classes = useStyles();
  const getConfigData = useSelector(getConfigs).toJS();
  const [isFetchingGlobal, globalPpisRaw] = useGlobalPpis({
    status: States.PUBLISHED
  });
  const globalPpis = toJS(globalPpisRaw, []);
  const [isFetchingPpis, ppi] = usePpis();
  const [isFetchingPpsis, raw] = usePpsis({});
  const [isfet, ingredientsRaw, allRawIngredients] = useIngredients({
    hasPpi: false
  });
  const ingredients = toJS(ingredientsRaw, []);
  const [bool, dishesRaw] = useDishes({ hasPpsi: false });
  const [isFetch, excludedDishesRaw] = useExcludedDishes({ hasPpi: false });
  const [isFetchin, exIngredientRaw] = useExcludedIngredients();
  const ppiRow = toJS(exIngredientRaw);
  const filters = useMemo(() => ({}), []);
  const dispatch = useDispatch();
  const ppsis = useSelector(getPpsisWithFilter(filters));
  const ppis = useSelector(getPpisNotUptoDate());
  const language = useSelector(getLanguage);
  const allIngredients = toJS(allRawIngredients, []);
  const localPpis = toJS(ppi);
  const newPpiAvailabelDataRaw = useSelector(getNewPpiAvailabelData);
  const newPpiAvailabelData = toJS(newPpiAvailabelDataRaw);
  const isGlobalUser = useSelector(getIsGlobalUser);

  // const [isFetchingGlobalPpis, globalPpisRaw] = useGlobalPpis();
  // const [isFetchingGlobalPpsis, globalPpsisRaw] = useGlobalPpsis();
  const isFetching =
    isFetchingPpis ||
    isFetchingPpsis ||
    isfet ||
    bool ||
    isFetch ||
    isFetchin ||
    isFetchingGlobal;
  const { isViewVisited } = useViewVisited('UPDATES_LIST', isFetching);
  const isFetched = isViewVisited ? true : !isFetching;

  const SearchColumns = {
    Type: {
      name: 'type',
      label: 'Type',
      dataField: 'type',
      filterable: true,
      sortable: false,
      width: 150,
      grow: 0,
      shrink: 0,
      searchable: false
    },
    Status: {
      name: 'status',
      calculateCellValue: rowData => {
        if (rowData.isUnused) {
          // return rowData.status;
          return 'New';
        }
        return getEnrichmentData(rowData).enrichmentStatus
          ? `${getEnrichmentData(rowData).enrichmentStatus}`
          : `${getEnrichmentData(rowData).status}`;
      },
      filterable: true,
      sortable: false,
      label: 'Status',
      width: 250,
      grow: 0,
      shrink: 0,
      searchable: false
    },
    Code: {
      name: 'code',
      label: 'iFood ID',
      calculateCellValue: rowData => {
        if (isRowPpsi(rowData)) {
          return formatFormulaCode(rowData.formulaCode, rowData.formulaVersion);
        } else {
          return rowData.ppiItemCode === undefined
            ? formatFormulaCode(rowData.itemCode)
            : formatFormulaCode(rowData.ppiItemCode);
        }
        // return formatFormulaCode(rowData.itemCode, rowData.formulaVersion);
        // return formatItemCode(rowData.itemCode);
      },
      width: 250,
      grow: 0,
      shrink: 0
    },
    PiaNumber: {
      name: 'piaNumber',
      label: 'PIA Number',
      dataField: 'piaArticleNumber',
      width: 200,
      grow: 0,
      shrink: 0
    },
    PresentationName: {
      name: 'presentationName',
      label: 'Product Name',
      calculateCellValue: (rowData, { language }) => {
        if (!Object.keys(rowData).includes('info') && rowData.type === 'Dish') {
          if (rowData.isUnused) {
            return rowData.presentationName[language];
          }
          return getEnrichmentData(rowData).presentationName[language];
        }
        let a = '';
        if (getEnrichmentData(rowData)) {
          if (rowData.isUnused) {
            a = rowData.presentationName[language];
          } else if (getEnrichmentData(rowData).info === undefined) {
            a = getEnrichmentData(rowData).presentationName[language];
          } else if (getEnrichmentData(rowData).info[language]) {
            a = getEnrichmentData(rowData).info[language].presentationName;
          }
        } else if (rowData.isUnused) {
          a = rowData.presentationName[language];
        }
        return a;
      },
      link: rowData => {
        return navigate(rowData);
      },
      width: 350,
      grow: 0,
      shrink: 0
    }
  };

  useEffect(() => {
    if (!isGlobalUser) {
      dispatch(fetchNewPPIAvilableData());
    }
  }, []);

  if (isFetching) {
    return <ProgressFullscreen />;
  }

  const globalPpisWithoutLocalPpi = excludePpis(globalPpis, localPpis);
  const globalPpi = includePpis(globalPpis, localPpis);

  const ss = [];
  const gp = globalPpi.filter(e => e.status === 'PUBLISHED');
  const fiData = allIngredients.filter(a =>
    gp.map(a => a.itemCode).includes(a.relationshipId)
  );
  const filter = fiData.filter(i =>
    localPpis.map(local => local.itemCode).includes(i.itemCode)
  );

  let array = [];
  filter.forEach(element => {
    gp.forEach(global => {
      if (element.relationshipId == global.itemCode) {
        array.push({
          ...global,
          ppiItemCode: element.itemCode,
          presentationName: element.presentationName
          //  ...element.presentationName = global.presentationName
        });
      }
    });
  });
  // Below logic written to handle display PRF's when FRF have multiple PRF's mapped (IFPPSI-1936)
  let unUsedPpis = [];
  filter.forEach(itm => {
    const locUsedData = localPpis
      .filter(a => a.itemCode === itm.itemCode)
      .map(
        element =>
          (element.inProgressPPIEnrichmentData &&
            element.inProgressPPIEnrichmentData.parentPpiId) ||
          (element.publishedPPIEnrichmentData &&
            element.publishedPPIEnrichmentData.parentPpiId)
      )
      .filter(a => a);

    array.forEach(element => {
      if (
        element.ppiItemCode === itm.itemCode &&
        !locUsedData.includes(element.id)
      ) {
        unUsedPpis.push(element);
      }
    });
  });

  // const unUsedPpis = removeDuplicates(ss);

  if (ingredients.length > 0 && globalPpisWithoutLocalPpi.length > 0) {
    for (var i = 0; i < globalPpisWithoutLocalPpi.length; i++) {
      const filteredList = ingredients.filter(item => {
        return item.relationshipId === globalPpisWithoutLocalPpi[i].itemCode;
      });
      if (filteredList.length > 0) {
        globalPpisWithoutLocalPpi[i].ppiItemCode = filteredList[0].itemCode;
        globalPpisWithoutLocalPpi[i].presentationName =
          filteredList[0].presentationName;
      } else {
        globalPpisWithoutLocalPpi[i].ppiItemCode = null;
        globalPpisWithoutLocalPpi[i].presentationName = null;
      }
    }
  }

  let globalPpisWithPPIItemCode = globalPpisWithoutLocalPpi;

  globalPpisWithPPIItemCode = globalPpisWithoutLocalPpi.filter(item => {
    if (item.ppiItemCode !== null) {
      return item;
    }
  });

  const GlobalPpiItemCode =
    globalPpisWithPPIItemCode &&
    globalPpisWithPPIItemCode.map(i => i.ppiItemCode);

  const ingredientsWithoutGlobalppi =
    ingredients &&
    ingredients.filter(i => !GlobalPpiItemCode.includes(i.itemCode));

  let arr_2338 = [];
  if (newPpiAvailabelData.length && localPpis.length) {
    const updateIds = includeNewPpiUpdateData(
      newPpiAvailabelData,
      localPpis,
      globalPpis
    ).map(a => a.itemCode);
    const UpdateIngredients = allIngredients.filter(a =>
      updateIds.includes(a.itemCode)
    );
    // const UpdateIngredients = includeNewPpiUpdateData(newPpiAvailabelData, localPpis)
    UpdateIngredients.forEach(element => {
      let globalSortedData = globalPpis.filter(
        a => a.itemCode === element.relationshipId
      );
      let sortedData = getLatestPublishedItem(globalSortedData);
      // globalPpis.forEach(global => {

      if (sortedData && element.relationshipId === sortedData.itemCode) {
        arr_2338.push({
          ...sortedData,
          ppiItemCode: element.itemCode,
          presentationName: element.presentationName
          //  ...element.presentationName = global.presentationName
        });
      }
      // });
    });
  }

  const ingredientsData = [
    ...(ingredients.length ? globalPpisWithPPIItemCode : []),
    ...(ingredients.length ? ingredientsWithoutGlobalppi : []),
    ...unUsedPpis.map(itm => ({ ...itm, itemCode: itm.ppiItemCode })),
    ...arr_2338
  ];

  const allData = createTableData(
    ppsis,
    ppis,
    dishesRaw,
    raw,
    excludedDishesRaw,
    ingredientsRaw,
    exIngredientRaw,
    ppi,
    searchParams.get('search'),
    language,
    fromJS(ingredientsData)
  );

  // const allDatas = allData.toJS();
  const allDatas = allData;
  const data = allDatas;

  View.Search.visit();
  return (
    <PaperContainer showProgress={!isFetched}>
      <Table
        // title="updatesList.updatesTableHeader"
        data={
          searchParams.get('search') && searchParams.get('search').length > 1
            ? data
            : []
        }
        columns={[
          SearchColumns.Code,
          SearchColumns.PresentationName,
          SearchColumns.PiaNumber,
          SearchColumns.Type,
          SearchColumns.Status
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'code', direction: 'asc' }]}
        selectable
        // showSearch={false}
        hideObjectText={false}
        showLanguageSelector={false}
        showOnlySearch
      />
    </PaperContainer>
  );
};

export default SearchListView;
